import { Link } from 'react-router-dom';
import styles from './HeaderRight.module.scss';

interface HeaderRightProps {
  searchComponent?: React.ReactNode;
}

export function HeaderRight({ searchComponent }: HeaderRightProps) {
  return (
    <div className={styles.container}>
      <div className={styles.searchComponent}>{searchComponent}</div>

      <div className={styles.contentContainer}>
        <Link className={styles.notificationsButton} to="/">
          <span className={styles.notificationsIcon} />
        </Link>
      </div>
    </div>
  );
}
